module.exports = __webpack_public_path__ + "fonts/HKNova-ExtraBold.df1779a8.woff2";